module.exports = __webpack_public_path__ + "icon_toolsblocks_top.da0d7b9b0416d0c35499.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_toolsblocks_top.svg
// module id = ./src/assets/img/icon_toolsblocks_top.svg
// module chunks = main